import type { UploadStatus } from "@winamp/media-upload/schema.js";

export function getIsUploading(upload: UploadStatus | undefined) {
  return (
    !!upload && ["uploading", "initialised", "started"].includes(upload.status)
  );
}
